<script>
export default {
  name: "TheMeetingParameterInformationDialog",

  props: {
    visible: Boolean
  },

  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
  },


}
</script>

<template>

  <v-dialog
    v-model="show"
    width="755px"
    content-class="rounded-xl"
  >
    <v-card class="rounded-xl">
      <v-card-title>
        <span class="text-h5">Информация по заполнению параметров комиссии</span>
      </v-card-title>

      <v-card-text>
        <span class="text-h6">Дата</span> Настоящее поле предназначено для определения даты, которая будет отображаться в выписке и протоколе комиссии.
      </v-card-text>

      <v-card-text>
        <span class="text-h6">Количество мест</span> Настоящее поле предназначено для отображения количества доступных мест для кандидатов на получение ПГАС.
        Данное поле является информативным и не является обязательным для заполнения. Информация о количестве доступных мест может быть изменена в любой момент.
      </v-card-text>

      <v-card-text>
        <span class="text-h6">Председатель</span>
        Настоящее поле предназначено для определения председателя комиссии. Для этого необходимо:
        1. Ввести ФИО председателя комиссии в поле для выбора.
        2. Из списка выбрать соответствующего председателя.
      </v-card-text>

      <v-card-text>
        <span class="text-h6">Секретарь</span>
        Настоящее поле предназначено для определения секретаря комиссии. Для этого необходимо:
        1. Ввести ФИО секретаря комиссии в поле для выбора.
        2. Из списка выбрать соответствующего секретаря.
      </v-card-text>

      <v-card-text>
        <span class="text-h6">Председатель студенческого актива</span>
        Настоящее поле предназначено для определения председателя студенческого актива комиссии. Для этого необходимо:
        1. Ввести ФИО председателя студенческого актива комиссии в поле для выбора.
        2. Из списка выбрать соответствующего председателя студенческого актива.
      </v-card-text>

      <v-card-text>
        <span class="text-h6">Слушатели</span>
        Настоящее поле предназначено для определения слушателей комиссии. Для этого необходимо:
        1. Ввести ФИО слушателя комиссии в поле для выбора.
        2. Из списка выбрать соответствующего слушателя.
        3. Повторить действие 1 и 2 пока не будут выбраны все слушатели.
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="teal darken-3"
          class="rounded-xl white--text"
          @click="show = false"
        >
          Закрыть
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<style scoped>

</style>